import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getIndustryRecentEpisode } from "../../../actions/industryofweek";
import { getEmployerRecentEpisode } from "../../../actions/employerspotlight";
import { login } from "../../../actions/auth";
import { setAlert } from "../../../actions/alert";

import Alert from "./Alert";
import BlackLogo from "./BlackLogo";

const LoggedOutNavAlt = ({
  login,
  industryweek: { currentepisode },
  getIndustryRecentEpisode,
  employerweek,
  getEmployerRecentEpisode,
}) => {
  const [profileDropDown, setprofileDropDown] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      setAlert("Please enter a valid email");
    }
    if (password === "") {
      setAlert("Please enter a password");
    }
    login(email, password);
  };

  useEffect(() => {
    getIndustryRecentEpisode();
    getEmployerRecentEpisode();
  }, [getIndustryRecentEpisode, getEmployerRecentEpisode]);

  return (
    <Fragment>
      <nav className="login-nav border-bottom light-grey background-white">
        <div className="login-container">
          <form
            className="main"
            action="/jobs"
            method="POST"
            onSubmit={(e) => onSubmit(e)}
          >
            <div className="action-items-index">
              <Link to="/register">
                <div className="action-button-alt">
                  <i className="fas fa-user action-icon-alt fa-lg black"></i>
                </div>
              </Link>
              <p className="action-text-alt">Register</p>
            </div>
            <div className="action-items-index">
              <div
                className="action-button-alt"
                onClick={() => {
                  if (!profileDropDown) {
                    setprofileDropDown(true);
                  } else {
                    setprofileDropDown(false);
                  }
                }}
              >
                <i className="fas fa-user action-icon-alt fa-lg black"></i>
              </div>
              <p className="action-text-alt">Login</p>
            </div>
            {profileDropDown && (
              <div className="profile-drop-down-light">
                <div className="profile-drop-container-nav">
                  <div className="label-input">
                    <label htmlFor="email" className="labels-alt bold black">
                      Email:
                    </label>
                    <input
                      name="email"
                      className="input-style-alt"
                      type="email"
                      value={email}
                      placeholder="Enter Email Address"
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  <div className="label-input">
                    <label htmlFor="password" className="labels-alt bold black">
                      Password:
                    </label>
                    <input
                      name="password"
                      className="input-style-alt"
                      type="password"
                      min={7}
                      maxLength={20}
                      value={password}
                      placeholder="Enter Password"
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  {email !== "" && password !== "" && (
                    <div className="login-button-container-alt">
                      <button
                        className="login-button-alt background-black white"
                        type="submit"
                      >
                        Login
                      </button>
                    </div>
                  )}
                  <Link to="/forgotpassword">
                    <p className="forgot bold black" tabIndex="4">
                      Forgot Password?
                    </p>
                  </Link>
                </div>
              </div>
            )}
          </form>
        </div>
        <div className="center-nav">
          <div className="index-logo-alt">
            <BlackLogo />
          </div>
          <div className="site-links-container">
            <div className="site-links">
              <ul className="links">
                <Link to="/">
                  <li className="link black bold">
                    <i className="fas fa-home black mx-5"></i>Home
                  </li>
                </Link>
                <Link to={`/industryofweek/${currentepisode.industryname}`}>
                  <div className="link black bold">
                    <i className="fas fa-calendar-week black mx-5"></i>
                    Industry of the Week
                  </div>
                </Link>
                <Link to="/liveonime">
                  <li className="link black bold">
                    <i className="fas fa-video black mx-5"></i>Live on ime
                  </li>
                </Link>
                <Link
                  to={`/employerspotlight/${employerweek.currentepisode.companyname}`}
                >
                  <div className="link black bold">
                    <i className="fa-solid fa-lightbulb  black mx-5"></i>
                    Employer Spotlight
                  </div>
                </Link>
                <Link to="/vrtours">
                  <li className="link black bold">
                    <i className="fas fa-street-view black mx-5"></i>VR Tours
                  </li>
                </Link>
                <Link to="/trending">
                  <li className="link black bold">
                    <i className="fas fa-fire black mx-5"></i>Trending
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <div className="buttons">
          <Link to="/employers">
            <div className="action-items-alt">
              <div className="action-button-alt">
                <i className="fas fa-user action-icon-alt fa-lg black"></i>
              </div>
              <p className="action-text-alt">Employers</p>
            </div>
          </Link>
          <Link to="/mentors">
            <div className="action-items-alt">
              <div className="action-button-alt">
                <i className="fas fa-user action-icon-alt fa-lg black"></i>
              </div>
              <p className="action-text-alt">Mentors</p>
            </div>
          </Link>
        </div>
      </nav>
    </Fragment>
  );
};

LoggedOutNavAlt.propTypes = (state) => ({
  login: PropTypes.func.isRequired,
  getIndustryRecentEpisode: PropTypes.func.isRequired,
  getEmployerRecentEpisode: PropTypes.func.isRequired,
});

const mapStateToProps = (state) => ({
  industryweek: state.industryweek,
  employerweek: state.employerweek,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  login,
  getIndustryRecentEpisode,
  getEmployerRecentEpisode,
})(LoggedOutNavAlt);
